import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
  FinanceValueObjectsSpendingAlertTypeEnum,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import type { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & { visible?: boolean; isDuplicatedExpenseEnabled?: boolean }

const spendingAlertFilter = ({
  expensesContext,
  visible = false,
  initialFilterValues,
}: Props): DataTableFilter<ExpensesExpensableFilter> => {
  const types: { label: string; value: FinanceValueObjectsSpendingAlertTypeEnum }[] = [
    {
      label: i18n.t('expenses_v2.list.filters.spending_alert_type.spending_policy'),
      value: 'spending_policy',
    },
    {
      label: i18n.t('expenses_v2.list.filters.spending_alert_type.mileage_rate_changed'),
      value: 'mileage_rate_changed',
    },
    {
      label: i18n.t('expenses_v2.list.filters.spending_alert_type.duplicate_expense'),
      value: 'duplicate_expense',
    },
    {
      label: i18n.t('expenses_v2.list.filters.spending_alert_type.category_conflict'),
      value: 'category_conflict',
    },
  ]

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: types,
        value: initialFilterValues.spendingAlert ?? [],
      },
    ],
    onUpdateValue: (filter) => {
      if (!filter) return

      trackFilters('spendingAlert', expensesContext, filter?.value)
    },
    identifier: 'expensesList.spendingAlertFilter',
    path: 'spendingAlertType',
    title: i18n.t('expenses_v2.list.filters.spending_alert_type.title'),
    default: visible,
  }
}

export default spendingAlertFilter
